<template>
    <n-modal :show="openUninvoiceModal" preset="card" title="Refund Item Request" size="small" :style="ModalStyle()">
        <template #header>
            Refund Item Request
        </template>
        <div v-if="isResponsePageShow == false">
            <n-form ref="formRef" :model="customerAction">
                <n-grid cols="1 500:4">
                    <n-grid-item>
                        <div class="item_img">
                            <img v-if="data.img_url !== '#'" :src="data.img_url" :alt="data.sku" style="width:80px;height:80Px">
                            <n-icon v-else size="80">
                                <Image />
                            </n-icon>
                        </div>
                    </n-grid-item>
                    <n-grid-item span="3">
                        <div class="item_details">
                            <div>{{data.desc}}</div>
                            <div style="font-size:11px">{{data.sku}} &nbsp; &nbsp;&nbsp; ${{data.price}}</div>
                            <div style="width:150px; display: inline-block">
                                <n-input-number  v-model:value="customerAction.uploadQty" size="small" :min="0" :max="customerAction.defaultQty" />
                            </div>
                        </div>
                    </n-grid-item>
                </n-grid>
                
                <hr style="border-color: white" />
                <n-grid cols="1 250:2 500:3">
                    <n-grid-item>
                        <div class="stock_space">AKL: <n-tag :type="stockStatus(data.stock_available_a)" size= "small">{{data.stock_available_a}} <span v-if="data.stock_available_a !== 'NO STOCK'">STOCK</span></n-tag></div>
                    </n-grid-item>
                    <n-grid-item>
                        <div class="stock_space">CHC: <n-tag :type="stockStatus(data.stock_available_c)" size= "small">{{data.stock_available_c}} <span v-if="data.stock_available_c !== 'NO STOCK'">STOCK</span></n-tag> </div>
                    </n-grid-item>
                    <n-grid-item>
                        <div class="stock_space">HAM: <n-tag :type="stockStatus(data.stock_available_d)" size= "small">{{data.stock_available_d}} <span v-if="data.stock_available_d !== 'NO STOCK'">STOCK</span></n-tag></div>
                    </n-grid-item>
                </n-grid>
                <span v-if="data.stock_available_a == 'NO STOCK' || data.stock_available_c == 'NO STOCK' || data.stock_available_d == 'NO STOCK'">
                <i style="color:red">*</i> Your Item(s) will dispatch from {{orderDetails.fulfilstorelocation}} <br/> <b>ETA: {{data.eta? new Date(data.eta).toUTCString().substr(4,13):""}}</b></span>
                <hr style="border-color: white" />
                <n-form-item path="command">
                    <n-input v-model:value="customerAction.command" type="textarea" placeholder="Please leave your message (optional)" :autosize="{ minRows: 3, maxRows: 5 }"/>
                </n-form-item>
                <n-space justify="end">
                        <n-button size="small" ghost type="error" @click="handleValidateClick" attr-type="button" :loading="isSubmitBtnLoading == true" :disabled="isSubmitBtnLoading == true">Refund</n-button>
                        <n-button size="small" @click="closeModal">Cancel</n-button>
                </n-space>
            </n-form>
        </div>
        <div v-else>

            <n-result status="success" title="Success" v-if="responseStatus == 'success'">
                <template #default>
                <div style="text-align:center; line-height:0.8">
                    <p>Your request <b>#91235</b> has been successfully sent. </p>
                    <p>You will receive an email notification shortly.</p>
                    <p>Our customer care team will contact you within the next 48 hours</p>
                </div>
                </template>
                <template #footer>
                    <n-button type="info" @click="closeModal">OK</n-button>
                </template>
            </n-result>

            <n-result status="error" title="Request Failed" description="Please Try again. Thank you (^u^)" v-if="responseStatus == 'error'">
                <template #footer>
                    <n-button type="error" ghost @click="closeModal">OK</n-button>
                </template>
            </n-result>
            
        </div>
    </n-modal>
</template>

<script>
import {NModal, NButton, NInput, NTag, NGrid, NGridItem, NSpace, NForm, NFormItem, NInputNumber, NResult, NIcon} from "naive-ui"
import {ref} from "vue"
import { Image } from '@vicons/ionicons5'

export default{
    name:"UninvoiceModal",
    props:["openUninvoiceModal","data", "orderDetails"],
    components:{
        NModal,
        NButton,
        NInput,
        NTag,
        NGrid,
        NGridItem,
        NSpace, 
        NForm, 
        NFormItem,
        NInputNumber,
        NResult,
        NIcon,
        Image
    },
    setup(props, {emit}){
        const formRef = ref(null)
        const isSubmitBtnLoading = ref(false)
        const isResponsePageShow = ref(false)
        const responseStatus = ref(null)
        const customerAction = ref({
            defaultQty:props.data.qty,
            uploadQty:0,
            command:""
        })

        const closeModal = () =>{
            emit('close')
            customerAction.value = null
        }

        const handleValidateClick  = () => {
            formRef.value.validate((errors) => {
            if (!errors) {
                isSubmitBtnLoading.value = true
                isResponsePageShow.value = true
                responseStatus.value = "error"

                console.log("customer command: ",customerAction.value.command)
                console.log("item info:", props.data)
                console.log("call api cancel")
                var ticketFormdata = new FormData()
                    
                ticketFormdata.append("name", props.orderDetails.billpersonfullname)
                ticketFormdata.append("phone", props.orderDetails.billpersonmobile)
                ticketFormdata.append("email",props.orderDetails.customeremail)
                ticketFormdata.append("description", customerAction.value.command)
                ticketFormdata.append("priority",3)
                ticketFormdata.append("status",2)
                ticketFormdata.append("source",100)
                ticketFormdata.append("type","Product Return/Refund")
                ticketFormdata.append("group_id", 51000167263)
                ticketFormdata.append("subject", `Refund Request - ${props.data.refnumber} - ${props.data.sku} X ${customerAction.value.uploadQty}`)
                for(var pair of ticketFormdata.entries()) {
                        console.log(pair[0]+ ', '+ pair[1]); 
                    }
                console.log(props.orderDetails)
            } else {
                console.log(errors)
            }
            })
        }

        const stockStatus = (stock) =>{
            if(stock == "HIGH") return "success"
            if(stock == "MEDIUM") return "warning"
            if(stock == "LOW") return "error"
            if(stock == "NO STOCK") return ""
        }

        const ModalStyle = () =>{
            if(document.body.clientWidth < 764) return "width:80%"
            if(document.body.clientWidth >= 764) return "width:550px"
        }

        return{
            formRef,
            isSubmitBtnLoading,
            isResponsePageShow,
            responseStatus,
            customerAction,
            closeModal,
            stockStatus,
            ModalStyle,
            // rules: {
            //     command: {
            //         required: true,
            //         message: 'Please leave you message',
            //         trigger: ['input']
            //     }
            // },
            handleValidateClick
        }
    },
}
</script>

<style scoped>

.stock_space{
    margin-bottom:5px
}


@media only screen and (max-width: 680px) {
  .item_img{
      text-align:center
  }

  .item_details{
      text-align:center
  }
}
</style>